import styled, { css } from 'styled-components';
import { containerPaddingM } from 'common/styles/variables';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import Logger from 'observability/Logger';

const LOG = new Logger('Spacer');

const RESPONSIVE_VERTICAL_CSS = ({ $spacing = containerPaddingM }) => {
    const isSpacingString = typeof $spacing === 'string';
    if (isSpacingString) {
        return css`
            padding-bottom: ${$spacing};
        `;
    }

    const responsiveCss = Object.keys($spacing).map((mediaName) => {
        if (mediaMaxWidth[mediaName]) {
            return css`
                ${mediaMaxWidth[mediaName]`
                        padding-bottom: ${$spacing[mediaName]};
                    `}
            `;
        } else if (mediaName === 'default') {
            return css`
                padding-bottom: ${$spacing[mediaName]};
            `;
        }

        LOG.warn('Invalid media value passed to Spacer', mediaName);
        return '';
    });

    return responsiveCss;
};

export default styled.div`
    ${RESPONSIVE_VERTICAL_CSS}
    ${({ $spacingY }) => ($spacingY ? `padding-right: ${$spacingY}` : '')}
`;
